import React,{ FC } from "react"
import { Image } from "antd-mobile";
import styles from "./index.module.less";
import classNames from "classnames";
import { game_toast_success, game_toast_warn } from "~src/assets/images/answerGame";

interface ToastContentProps {
  content: string
  value: boolean
}
const Toastcontent: FC<ToastContentProps> = ({ value ,content}) => {
  return <div className={styles.toast}>
    <Image className={styles.game_toast_warn} src={value?game_toast_success :game_toast_warn}></Image>
    <div className={classNames(styles["toast-text"], value ? styles["toast-success"] : styles["toast-warn"])}>{content}</div>
  </div>
}

export default Toastcontent